import SectionHeading from "./SectionHeading";
import { guideSteps } from "@/mocks/shows";

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="追剧指南"
          title="从挑剧到看完一季的四步流程"
          description="追剧的体验好坏，往往取决于开始的方式。下面这套顺序适用于大多数连载剧，熟练之后可以自由调整。"
        />

        <div className="mt-9 grid items-start gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="reveal relative overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <div className="aspect-[4/3] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20evening%20living%20room%20with%20warm%20lamp%20light%2C%20person%20relaxing%20on%20sofa%20watching%20a%20drama%20on%20a%20large%20screen%2C%20amber%20and%20cream%20tones%2C%20soft%20shadows%2C%20editorial%20lifestyle%20photography%2C%20calm%20atmosphere%2C%20high%20detail&width=1000&height=750&seq=guide-view-01&orientation=landscape"
                alt="在家中沙发上用大屏观看剧集的追剧场景"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-5">
              <p className="text-sm text-background-100">
                固定一个时段追剧，比零散地跳着看更容易跟上剧情节奏。
              </p>
            </div>
          </div>

          <ol className="flex flex-col gap-4">
            {guideSteps.map((step) => (
              <li
                key={step.step}
                className="reveal flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 font-heading text-base font-bold text-background-50">
                  {step.step}
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {step.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-7 text-foreground-600">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}